import { render, staticRenderFns } from "./AllotOrderPrint.vue?vue&type=template&id=7c3d36c6&scoped=true&"
import script from "./AllotOrderPrint.vue?vue&type=script&lang=js&"
export * from "./AllotOrderPrint.vue?vue&type=script&lang=js&"
import style0 from "./AllotOrderPrint.vue?vue&type=style&index=0&id=7c3d36c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d36c6",
  null
  
)

export default component.exports